import { createContext, type ComponentType } from 'react'

/**
 * What the success page draws under *Ďakujeme!* that another module owns - `FRONTEND.md` §9.779, owner O138f.
 *
 * The success page is `customer-checkout`'s and the mini-games are `customer-account`'s, and §5 lets neither
 * import the other. So a module names a surface in its contract (`orderPlaced`, beside `banners`), the shell
 * composes the list and provides it here, and the page draws whatever it is handed. The shell still knows no
 * feature and the checkout still knows no game.
 *
 * Drawn only for an order this tab has just placed; the page decides that, and each surface decides the rest
 * (the games: signed in, running, a play left today).
 */
export interface OrderPlacedSurface {
  /** Names the surface, so a duplicate mount is visible rather than silent. */
  name: string
  component: ComponentType
}

export const OrderPlacedContext = createContext<readonly OrderPlacedSurface[]>([])
